import { render, staticRenderFns } from "./CoreForm.vue?vue&type=template&id=59ca556e&"
import script from "./CoreForm.vue?vue&type=script&lang=js&"
export * from "./CoreForm.vue?vue&type=script&lang=js&"
import style0 from "./CoreForm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/CoreForm.vue
// module id = 153
// module chunks = 0